import Swiper from "swiper";

export function initAdvantagesSlider(){

    const swiper = new Swiper('#advantages_slider', {
        speed: 900,
        slidesPerView: 3,
        spaceBetween: 40,
        breakpoints: {
            0: {
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            500:{
                slidesPerView: 'auto',
                spaceBetween: 20
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1000: {
                slidesPerView: 3,
                spaceBetween: 40
            }
        }
    });

}